(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collage-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('topdc-scenario-collage')) {
    customElements.define('topdc-scenario-collage', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.scroller = this.querySelector('.topdc-scenarios__scroller');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.referenceMotion = this.hasAttribute('data-reference-motion');
        this.compact = window.matchMedia('(max-width: 1023px)');
        this.inView = false;
        this.compact.addEventListener('change', () => {
          this.activate(null);
          this.updateVisibleCard();
          this.updateNavigation();
        }, options);
        this.motion.addEventListener('change', () => {
          const card = this.activeCard;
          this.activate(null);
          this.activate(card);
        }, options);
        this.previousButton = this.querySelector('[data-scenario-previous]');
        this.nextButton = this.querySelector('[data-scenario-next]');
        this.positionLabel = this.querySelector('[data-scenario-position]');
        this.previousButton.addEventListener('click', () => this.navigate(-1), options);
        this.nextButton.addEventListener('click', () => this.navigate(1), options);
        this.scroller.addEventListener('scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.updateNavigation();
            this.updateVisibleCard();
          });
        }, { ...options, passive: true });
        this.scroller.addEventListener('touchstart', event => {
          this.touchGesture = event.touches.length === 1 ? {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY,
            left: this.scroller.scrollLeft,
            dragging: false
          } : null;
        }, { signal: this.controller.signal, passive: true });
        this.scroller.addEventListener('touchmove', event => {
          const gesture = this.touchGesture;
          if (!gesture || event.touches.length !== 1) return;
          const dx = event.touches[0].clientX - gesture.x;
          const dy = event.touches[0].clientY - gesture.y;
          if (!gesture.dragging) {
            if (Math.abs(dy) > 8 && Math.abs(dy) >= Math.abs(dx)) {
              this.touchGesture = null;
              return;
            }
            if (Math.abs(dx) <= 8 || Math.abs(dx) <= Math.abs(dy)) return;
            gesture.dragging = true;
            this.scroller.classList.add('is-dragging');
          }
          if (event.cancelable) event.preventDefault();
          this.scroller.scrollLeft = gesture.left - dx;
        }, { signal: this.controller.signal, passive: false });
        const finishTouch = () => {
          const gesture = this.touchGesture;
          this.touchGesture = null;
          if (!gesture?.dragging) return;
          const cards = [...this.querySelectorAll('.topdc-scenarios__card')];
          const index = this.currentIndex();
          this.scroller.classList.remove('is-dragging');
          if (cards[index]) this.scroller.scrollTo({
            left: cards[index].offsetLeft - cards[0].offsetLeft,
            behavior: this.motion.matches ? 'instant' : 'smooth'
          });
        };
        this.scroller.addEventListener('touchend', finishTouch, { signal: this.controller.signal, passive: true });
        this.scroller.addEventListener('touchcancel', finishTouch, { signal: this.controller.signal, passive: true });
        this.addEventListener('transitionend', event => {
          this.updateNavigation();
          if (this.referenceMotion && event.target === this.activeCard && event.propertyName === 'flex-basis') this.ensureActiveVisible();
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          this.updateNavigation();
          this.updateVisibleCard();
        });
        this.resizeObserver.observe(this.scroller);
        this.updateNavigation();
        this.addEventListener('pointerover', event => {
          if (event.pointerType === 'touch') return;
          const card = event.target.closest('.topdc-scenarios__card');
          if (card && this.contains(card)) this.activate(card);
        }, options);
        this.addEventListener('pointerleave', () => {
          if (!this.compact.matches && !this.contains(document.activeElement)) this.activate(null);
        }, options);
        this.addEventListener('focusin', event => {
          const card = event.target.closest('.topdc-scenarios__card');
          if (card) this.activate(card);
        }, options);
        this.addEventListener('focusout', event => {
          if (!this.compact.matches && !this.contains(event.relatedTarget)) this.activate(null);
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (!this.inView) this.activate(null);
          else this.updateVisibleCard();
        }, { threshold: 0 });
        this.observer.observe(this);
      }
      updateVisibleCard() {
        if (!this.referenceMotion || !this.compact.matches || !this.inView) return;
        const cards = [...this.querySelectorAll('.topdc-scenarios__card')];
        this.activate(cards[this.currentIndex()] || null);
      }
      ensureActiveVisible() {
        if (!this.activeCard || this.compact.matches) return;
        const bounds = this.scroller.getBoundingClientRect();
        const card = this.activeCard.getBoundingClientRect();
        const delta = card.left < bounds.left ? card.left - bounds.left : Math.max(0, card.right - bounds.right);
        if (Math.abs(delta) > 1) this.scroller.scrollBy({ left: delta, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      currentIndex() {
        const cards = [...this.querySelectorAll('.topdc-scenarios__card')];
        if (!cards.length) return 0;
        const start = cards[0].offsetLeft;
        const maximum = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        let nearest = 0;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const delta = Math.abs(Math.min(maximum, card.offsetLeft - start) - this.scroller.scrollLeft);
          if (delta < distance) {
            nearest = index;
            distance = delta;
          }
        });
        return nearest;
      }
      updateNavigation() {
        const count = this.querySelectorAll('.topdc-scenarios__card').length;
        this.previousButton.disabled = this.scroller.scrollLeft <= 2;
        this.nextButton.disabled = this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 2;
        if (this.positionLabel) this.positionLabel.textContent = count ? (this.currentIndex() + 1) + ' / ' + count : '0 / 0';
      }
      navigate(direction) {
        const behavior = this.motion.matches ? 'instant' : 'smooth';
        if (window.matchMedia('(max-width: 1023px)').matches) {
          const cards = [...this.querySelectorAll('.topdc-scenarios__card')];
          if (!cards.length) return;
          const next = Math.max(0, Math.min(cards.length - 1, this.currentIndex() + direction));
          this.scroller.scrollTo({ left: cards[next].offsetLeft - cards[0].offsetLeft, behavior });
        } else {
          this.scroller.scrollBy({ left: direction * this.scroller.clientWidth * .5, behavior });
        }
      }
      activate(card) {
        if (card === this.activeCard) return;
        this.querySelectorAll('.topdc-scenarios__card').forEach(item => {
          item.classList.toggle('is-active', item === card);
          item.classList.remove('is-playing');
          const video = item.querySelector('video');
          if (video) {
            video.onplaying = null;
            video.pause();
            if (this.referenceMotion && video.readyState > 0) video.currentTime = 0;
          }
        });
        this.activeCard = card;
        if (!card) return;
        if (this.referenceMotion && this.motion.matches) this.ensureActiveVisible();
        const video = card.querySelector('video');
        if (video && !this.motion.matches) {
          video.muted = true;
          video.playsInline = true;
          video.onplaying = () => {
            if (this.activeCard === card) card.classList.add('is-playing');
          };
          video.play().catch(() => { if (this.activeCard === card) card.classList.remove('is-playing'); });
        }
      }
      disconnectedCallback() {
        this.activate(null);
        this.controller?.abort();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-photo-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('customer-photo-reviews')) {
  customElements.define('customer-photo-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.scroller = this.querySelector('.customer-photo-reviews__grid');
      this.cards = [...this.querySelectorAll('.customer-review-card')];
      this.previousButton = this.querySelector('[data-reviews-previous]');
      this.nextButton = this.querySelector('[data-reviews-next]');
      this.position = this.querySelector('[data-reviews-position]');
      this.controls = this.querySelector('.customer-photo-reviews__controls');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.classList.add('is-enhanced');
      this.addEventListener('click', event => {
        const toggle = event.target.closest('[data-review-toggle]');
        if (!toggle || !this.contains(toggle)) return;
        const card = toggle.closest('.customer-review-card');
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        card.dataset.expanded = String(expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? this.dataset.labelLess : this.dataset.labelMore;
      }, options);
      this.previousButton.addEventListener('click', () => this.navigate(-1), options);
      this.nextButton.addEventListener('click', () => this.navigate(1), options);
      this.scroller.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateNavigation(); });
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => { this.updateNavigation(); this.updateExcerpts(); });
      this.resizeObserver.observe(this.scroller);
      this.updateNavigation();
      this.updateExcerpts();
      document.fonts.ready.then(() => { if (this.isConnected) this.updateExcerpts(); });
    }
    updateExcerpts() {
      this.cards.forEach(card => {
        const button = card.querySelector('[data-review-toggle]');
        if (!button || card.dataset.expanded === 'true') return;
        const text = card.querySelector('.customer-review-card__text');
        const title = card.querySelector('.customer-review-card__title');
        button.hidden = !(text?.scrollHeight > text?.clientHeight + 1 || title?.scrollHeight > title?.clientHeight + 1);
      });
    }
    currentIndex() {
      if (!this.cards.length) return 0;
      const start = this.cards[0].offsetLeft;
      const maximum = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      let nearest = 0, distance = Infinity;
      this.cards.forEach((card, index) => {
        const delta = Math.abs(Math.min(maximum, card.offsetLeft - start) - this.scroller.scrollLeft);
        if (delta < distance) { distance = delta; nearest = index; }
      });
      return nearest;
    }
    navigate(direction) {
      if (!this.cards.length) return;
      const index = Math.max(0, Math.min(this.cards.length - 1, this.currentIndex() + direction));
      this.scroller.scrollTo({ left: this.cards[index].offsetLeft - this.cards[0].offsetLeft, behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    updateNavigation() {
      this.controls.hidden = this.scroller.scrollWidth <= this.scroller.clientWidth + 2;
      this.previousButton.disabled = this.scroller.scrollLeft <= 2;
      this.nextButton.disabled = this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 2;
      this.position.textContent = this.cards.length ? `${this.currentIndex() + 1} / ${this.cards.length}` : '0 / 0';
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topdc-brand-strength"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('topdc-brand-strength')) {
    customElements.define('topdc-brand-strength', class extends HTMLElement {
      connectedCallback() {
        this.counters = [...this.querySelectorAll('[data-counter-value]')].map(element => {
          const finalText = element.dataset.counterValue;
          const match = finalText.match(/^([^\d]*)(\d[\d,]*(?:\.\d+)?)(.*)$/);
          if (!match) return null;
          const numericText = match[2];
          const target = Number(numericText.replaceAll(',', ''));
          if (!Number.isFinite(target)) return null;
          const decimals = numericText.includes('.') ? numericText.split('.')[1].length : 0;
          const formatter = new Intl.NumberFormat('en-US', {
            useGrouping: numericText.includes(','),
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          });
          return { element, finalText, target, prefix: match[1], suffix: match[3], formatter, decimals };
        }).filter(Boolean);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.dataset.animate === 'false' || this.motion.matches || this.hasPlayed || !this.counters.length) {
          this.finish();
          return;
        }
        this.duration = Math.min(2400, Math.max(800, Number(this.dataset.duration) || 1400));
        this.controller = new AbortController();
        this.motion.addEventListener('change', event => { if (event.matches) this.finish(); }, { signal: this.controller.signal });
        this.counters.forEach(counter => {
          counter.element.textContent = counter.prefix + counter.formatter.format(0) + counter.suffix;
        });
        this.dataset.counterState = 'waiting';
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.start();
          }
        }, { threshold: .2 });
        this.observer.observe(this);
      }
      start() {
        if (this.hasPlayed) return;
        this.hasPlayed = true;
        this.dataset.counterState = 'running';
        const began = performance.now();
        const update = now => {
          const progress = Math.min(1, (now - began) / this.duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.counters.forEach(counter => {
            const value = counter.target * eased;
            counter.element.textContent = counter.prefix + counter.formatter.format(counter.decimals ? value : Math.floor(value)) + counter.suffix;
          });
          if (progress < 1) this.frame = requestAnimationFrame(update);
          else this.finish();
        };
        this.frame = requestAnimationFrame(update);
      }
      finish() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.counters?.forEach(counter => { counter.element.textContent = counter.finalText; });
        this.dataset.counterState = 'complete';
      }
      disconnectedCallback() {
        this.finish();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topdc-tabbed-selections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('topdc-product-selections')) {
 class TopdcProductSelections extends HTMLElement {
  connectedCallback() {
   if(this.controller)return;
   this.controller=new AbortController();
   const opts={signal:this.controller.signal};
   this.tabs=Array.from(this.querySelectorAll('[data-selection-tab]'));
   this.panels=Array.from(this.querySelectorAll('[data-selection-panel]'));
   this.tabs.forEach((tab,index)=>{
    tab.addEventListener('click',()=>this.activate(index),opts);
    tab.addEventListener('keydown',event=>{
     let next=index;
     const rtl=getComputedStyle(this).direction==='rtl';
     if(event.key==='ArrowRight')next=(index+(rtl?-1:1)+this.tabs.length)%this.tabs.length;
     else if(event.key==='ArrowLeft')next=(index+(rtl?1:-1)+this.tabs.length)%this.tabs.length;
     else if(event.key==='Home')next=0;
     else if(event.key==='End')next=this.tabs.length-1;
     else return;
     event.preventDefault();this.activate(next,true);
    },opts);
   });
   document.addEventListener('shopify:block:select',event=>{
    const index=this.tabs.findIndex(tab=>tab.dataset.blockId===event.detail.blockId);
    if(index>=0&&event.target.closest('topdc-product-selections')===this)this.activate(index);
   },opts);
   this.activate(Math.max(0,this.tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true')),false,false);
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
  activate(index,focus=false,scroll=true) {
   if(!this.tabs[index])return;
   this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
   this.panels.forEach((panel,i)=>panel.hidden=i!==index);
   const tab=this.tabs[index],link=this.querySelector('[data-selection-view-all]');
   if(link){link.hidden=!tab.dataset.viewUrl;if(tab.dataset.viewUrl){link.href=tab.dataset.viewUrl;link.setAttribute('aria-label',tab.dataset.viewLabel);}else link.removeAttribute('href');}
   if(focus)tab.focus({preventScroll:true});
   if(scroll){
    const scroller=this.querySelector('.tst__tabs'),r=tab.getBoundingClientRect(),p=scroller.getBoundingClientRect();
    if(r.left<p.left||r.right>p.right)scroller.scrollBy({left:r.left+r.width/2-p.left-p.width/2,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   }
  }
 }
 customElements.define('topdc-product-selections',TopdcProductSelections);
}

  } catch(e) { console.error(e); }
})();
})();
